import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';

const BASE_URL = process.env.REACT_APP_MAIN_URL

export const AddRequisition = createAsyncThunk(
  "requisition/AddRequisition",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/requisition/create/`, data)
    return response.data
  }
); 

export const UpdateRequisition = createAsyncThunk(
  "requisition/UpdateRequisition",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/requisition/update/${data.id}/`, data)
    return response.data
  }
);

export const DeleteRequisition = createAsyncThunk(
  "requisition/DeleteRequisition",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/requisition/delete/${id}/`)
    if (response.status === 226){
      toast.dismiss();
      toast.warning("Requisition is in use. Can't delete!!!😣")
    }
    return response.status
  }
);

export const GetRequisitions = createAsyncThunk(
  "requisition/GetRequisitions",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/requisition/list/`);
    return data
  }
);

export const GetRequisitionItems = createAsyncThunk(
  "requisition/GetRequisitionItems",
  async (id) => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/requisition/item/list/${id}/`)
    return data
  }
);

export const DeleteRequisitionItem = createAsyncThunk(
  "requisition/DeleteRequisitionItem",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/requisition/item/delete/${id}/`)
    return response.status
  }
);


export const GetRequisitionItemsForWorkOrder = createAsyncThunk(
  "requisition/GetRequisitionItemsForWorkOrder",
  async (id) => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/requisition/item/list/for/work/order/${id}/`)
    return data
  }
);